import ReactGA from 'react-ga4';
const MEASURMENT_ID = process.env.REACT_APP_MEASUREMENT_ID;

export const initializeAnalytics = () => {
    if (!MEASURMENT_ID) {
        console.warn(
            'Google Analytics Measurement ID is missing'
        );
        return;
    }
    ReactGA.initialize(MEASURMENT_ID);
};

export const trackEvent = (
    eventName,
    parameters = {}
) => {
    ReactGA.event(
        eventName,
        parameters
    );
};